import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheUniversalMetaRuntime from "./sections/TheUniversalMetaRuntime";
import MySacredMission from "./sections/MySacredMission";
import OurExpertRepairServices from "./sections/OurExpertRepairServices";
import InvestmentPotential from "./sections/InvestmentPotential";
import VamosExpandirSeusNegocios from "./sections/VamosExpandirSeusNegocios";
import ReliabilityFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheUniversalMetaRuntime />
      <MySacredMission />
      <OurExpertRepairServices />
      <InvestmentPotential />
      <VamosExpandirSeusNegocios />
      <ReliabilityFooter />
    </div>;
}